import { render, staticRenderFns } from "./VistaHome.vue?vue&type=template&id=3506fa30&scoped=true&"
import script from "./VistaHome.vue?vue&type=script&lang=ts&"
export * from "./VistaHome.vue?vue&type=script&lang=ts&"
import style0 from "./VistaHome.vue?vue&type=style&index=0&id=3506fa30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3506fa30",
  null
  
)

export default component.exports